export const Colors = {
  primary: '#ed5f00',
};
